import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Epic } from "../../interfaces/epic";
import { Utils } from "../../utils/utils";

@Injectable()
export class EpicService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  async get(id): Promise<Epic> {
    let response = await this.http
      .get<any>(this.env.managirUrl + "/epics/" + id, {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
    return response.EpicResponse.epics[0];
  }

  getEpicsByProjectId(projectId): Promise<Epic[]> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/epics", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.EpicResponse.epics);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  /**
   * Creates a new epic in the database.
   * @param epic Epic to be created.
   */
  createEpic(epic: Epic): Promise<Epic> {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/epics", epic, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.EpicResponse.epics[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  /**
   * Updates an existing epic in the database.
   * @param epic Epic that should be updated.
   */
  saveEpic(epic: Epic) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(this.env.managirUrl + "/epics/" + epic._id, epic, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteEpicById(epicId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(this.env.managirUrl + "/epics/" + epicId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  /**
   * Creates and retrieves and empty epic with a default color and the specified project id.
   * @param projectId Project id to be used for the new epic.
   */
  getEmptyEpic(projectId: string): Epic {
    let emptyEpic: Epic = {
      projectId: projectId,
      color: Utils.presetThemeColors[0][0], // use default color
      epicLinksFrom: [],
      epicLinksTo: [],
      annotationLinks: [],
    } as Epic;

    return emptyEpic;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/epic/epic.service.ts